import moment from "moment-jalaali";
import WARRANTY_TEMPLATE from "../../../assets/images/warantyTemplate.JPG";
import IRANSansRegular from "../../../assets/fonts/woff2/IRANSansWeb(FaNum).woff2";
import IRANSansBold from "../../../assets/fonts/woff2/IRANSansWeb(FaNum)_Bold.woff2";

const escapeHtml = (value) =>
    String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

const dateOnlyFormat = (date) =>
    date ? moment.utc(date).locale("fa").format("jYYYY/jMM/jDD") : "";

export default function printWarranty({
    item,
    order,
    fallbackOrder,
    customer: customerOverride,
}) {
    const source = order || fallbackOrder || {};
    const customer = customerOverride || source?.user || fallbackOrder?.user || {};
    const englishPrefix = customer.gender === "male" ? "Mr." : "Ms.";
    const englishFullName = `${englishPrefix} ${customer.firstNameEnglish || ""} ${
        customer.lastNameEnglish || ""
    }`.trim();
    const persianPrefix = customer.gender === "male" ? "آقا" : "خانم";
    const fullName = `${persianPrefix} ${customer.fullName || ""}`.trim();
    const glassBrand = item.brand || "";
    const glassName = item.name || "";
    const date = dateOnlyFormat(source?.createDate || fallbackOrder?.createDate);
    const code = source?.trackingCode || fallbackOrder?.trackingCode || "";
    const glassesImage = item.frontImage || "";

    const englishText = `Thank you for your purchase from the Inakshop application, it is hereby confirmed that the glasses purchased by ${englishFullName} of the brand ${glassBrand} model ${glassName} is completely original and has passed all quality and authenticity control steps. This certificate of authenticity is a guarantee of the quality and originality of the product. Thank you for your choice and we hope you have a wonderful shopping experience.`;
    
    const persianText = `با تشکر از خرید شما از اپلیکیشن آینک‌شاپ، بدین‌وسیله تأیید می‌شود که عینک خریداری‌شده توسط ${fullName} عزیز از برند ${glassBrand} مدل ${glassName} کاملاً اورجینال بوده و تمام مراحل کنترل کیفیت و اصالت را گذرانده است. این گواهی اصالت تضمینی بر کیفیت و اصل بودن محصول می‌باشد.`;
    const persianText2 = ` از انتخاب شما سپاسگزاریم و امیدواریم تجربه‌ای فوق‌العاده از خرید خود داشته باشید.`
    const printWindow = window.open("", "_blank", "width=900,height=1200");
    if (!printWindow) return;

    printWindow.document.write(`
        <!doctype html>
        <html lang="fa" dir="rtl">
        <head>
            <meta charset="utf-8" />
            <title>گارانتی ${escapeHtml(code)}</title>
            <style>
                @font-face {
                    font-family: "IRANSans";
                    src: url("${IRANSansRegular}") format("woff2");
                    font-weight: 400;
                    font-style: normal;
                    font-display: swap;
                }
                @font-face {
                    font-family: "IRANSans";
                    src: url("${IRANSansBold}") format("woff2");
                    font-weight: 700;
                    font-style: normal;
                    font-display: swap;
                }
                @page { size: 138mm 189mm; margin: 0; }
                * { box-sizing: border-box; }
                html, body {
                    width: 138mm;
                    height: 189mm;
                    margin: 0;
                    overflow: hidden;
                    background: #fff;
                }
                body {
                    font-family: "IRANSans", sans-serif;
                    color: #111;
                }
                .warranty-page {
                    position: relative;
                    width: 138mm;
                    height: 189mm;
                    overflow: hidden;
                    background: #fff;
                }
                .template {
                    position: absolute;
                    inset: 0;
                    display: block;
                    width: 138mm;
                    height: 189mm;
                    object-fit: fill;
                }
                .glasses {
                    position: absolute;
                    top: 27.36mm;
                    left: 26.94mm;
                    width: 84.77mm;
                    height: 33.09mm;
                    object-fit: contain;
                }
                .text-block {
                }
                .english {
                    position: absolute;
                    top: 72.55mm;
                    direction: ltr;
                    font-size: 8.27pt;
                    line-height: 1.45;
                    font-style: italic;

                    left: 15.77mm;
                    right: 15.77mm;
                    text-align: justify;
                    text-justify: inter-word;
                    color: #111;
                }
                .persian {
                    position: absolute;
                    top: 99.27mm;
                    direction: rtl;
                    font-size: 8.91pt;
                    line-height: 1.8;
                    left: 15.77mm;
                    right: 15.77mm;
                    text-align: justify;
                    text-justify: inter-word;
                    color: #111;
                }
                .meta {
                    position: absolute;
                    right: 30.89mm;
                    direction: ltr;
                    text-align: left;
                    font-size: 7.64pt;
                    color: #111;
                }
                .date { 
                    top: 136.18mm;
                    right: 14.46mm;
                }
                .code { 
                    top: 141.27mm;
                    right: 14.46mm;
                    }
                @media print {
                    html, body {
                        print-color-adjust: exact;
                        -webkit-print-color-adjust: exact;
                    }
                    .warranty-page {
                        page-break-after: avoid;
                        page-break-inside: avoid;
                    }
                }
            </style>
        </head>
        <body>
            <main class="warranty-page">
                <img class="template" src="${WARRANTY_TEMPLATE}" alt="" />
                ${glassesImage ? `<img class="glasses" src="${escapeHtml(glassesImage)}" alt="" />` : ""}
                <div class="text-block english">${escapeHtml(englishText)}</div>
                <div class="persian">
                <div class="text-block">${escapeHtml(persianText)}</div>
                <div class="text-block">${escapeHtml(persianText2)}</div>
                </div>
                <div class="meta date">تاریخ خرید: ${escapeHtml(date)}</div>
                <div class="meta code">شماره سفارش: ${escapeHtml(code)}</div>
            </main>
            <script>
                function printWhenReady() {
                    var images = Array.prototype.slice.call(document.images);
                    var pending = images.filter(function(img) { return !img.complete; });
                    if (!pending.length) {
                        setTimeout(function() {
                            window.focus();
                            window.print();
                        }, 150);
                        return;
                    }
                    var done = 0;
                    pending.forEach(function(img) {
                        var finish = function() {
                            done += 1;
                            if (done === pending.length) printWhenReady();
                        };
                        img.onload = finish;
                        img.onerror = finish;
                    });
                }
                window.onload = printWhenReady;
            </script>
        </body>
        </html>
    `);
    printWindow.document.close();
}
